var map = {
	"./1.jpg": 71,
	"./2.jpg": 5320,
	"./3.jpg": 8837,
	"./4.jpg": 1457,
	"./5.jpg": 5323,
	"./6.jpg": 8876,
	"./all/1/03墩墩猪肉粒.jpg": 8662,
	"./all/1/04原切猪肉片.jpg": 7418,
	"./all/1/1.jpg": 5503,
	"./all/1/12酥酥猪肉松条.jpg": 8659,
	"./all/1/2.jpg": 1888,
	"./all/1/3.jpg": 1117,
	"./all/1/4.jpg": 9654,
	"./all/2/03太丰食趣礼盒食中之趣，不亦说乎.jpg": 7183,
	"./all/2/1.png": 7091,
	"./all/2/2.jpg": 6947,
	"./all/2/3.jpg": 8534,
	"./all/3/1.jpg": 5961,
	"./all/3/2.jpg": 14,
	"./all/3/3.png": 2243,
	"./all/4/07弹弹牛板筋.jpg": 8881,
	"./all/4/08火火辣牛肉.jpg": 5778,
	"./all/4/09糯糯牛筋肉.jpg": 7781,
	"./all/4/1.jpg": 8974,
	"./all/4/10轻享卤牛肉.jpg": 6784,
	"./all/4/11酱牛肉.jpg": 1436,
	"./all/4/12风琴牛肉干.jpg": 4776,
	"./all/4/13魔方卤牛肉.jpg": 1059,
	"./all/4/14鲜鲜卤牛腱.jpg": 998,
	"./all/4/15轻炙·原切牛肉片.jpg": 8753,
	"./all/4/16原切牛肉条.jpg": 5979,
	"./all/4/17.png": 8079,
	"./all/4/2.jpg": 1465,
	"./all/4/3.jpg": 5359,
	"./all/4/4.jpg": 1527,
	"./all/4/5.jpg": 2522,
	"./all/4/6.jpg": 9861,
	"./all/5/05托塔小饼干.jpg": 3152,
	"./all/5/06糯叽叽梅饼.jpg": 7650,
	"./all/5/07浮云牛轧奶酥.jpg": 9061,
	"./all/5/08爆爆肉弹肠.jpg": 5116,
	"./all/5/09玉米花系列.jpg": 2222,
	"./all/5/1.jpg": 5107,
	"./all/5/10脆脆肉脯.jpg": 5203,
	"./all/5/11蜜汁鸭翅根.jpg": 2636,
	"./all/5/15咔嚓鸡排脆.jpg": 4860,
	"./all/5/17.jpg": 8760,
	"./all/5/2.jpg": 948,
	"./all/6/1.jpg": 5928,
	"./all/6/13金衣腰果.jpg": 3445,
	"./all/6/14陈皮瓜子.jpg": 8452,
	"./all/6/16黄瓜味腰果.jpg": 2141,
	"./all/6/2.jpg": 151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2190;